import { useEffect } from 'react';

import { useCognitoCheckUser, useCurrentUser } from '@/entities/user/currentUser';

export const useInitRick = () => {
  const { data: user } = useCurrentUser();
  const { data: cognitoUser } = useCognitoCheckUser();

  useEffect(() => {
    if (user?.id && cognitoUser?.cognitoId) {
      // Инициализируем rickq если его нет
      if (!window.rickq) {
        window.rickq = [];
      }

      const userId = user.id;
      const cognitoID = cognitoUser.cognitoId!;

      // Устанавливаем контекст для Rick.js
      window.rickq?.push(
        {
          context: {
            cognitoID,
            rask_user_id: userId,
          },
        },
        {
          user_properties: {
            cognitoID,
            rask_user_id: userId,
          },
        },
      );
    }
  }, [user?.id, cognitoUser]);
};
